import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-usuarios",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./usuarios.component.html"
})
export class UsuariosComponent {}
